/**
 * Lifespace theme switching.
 *
 * Sets the `data-space` attribute on `<html>`. The CSS
 * `[data-space="<id>"]` blocks in globals.scss define the
 * `--space-50` … `--space-950` overrides — values are algorithmically
 * generated from each lifespace's `paletteSlot` in `themes.json`
 * (see tools/theme-editor/src/lib/lifespaceGenerator.ts).
 *
 * `personal` is the default. It uses the `--space-*` values from `:root`
 * and therefore needs NO `data-space` attribute — we remove it instead so
 * the cascade hits `:root` directly without a phantom selector match.
 */

export function applySpaceTheme(spaceId: string): void {
  const mapped = spaceId === 'all' ? 'personal' : spaceId
  if (mapped === 'personal') {
    document.documentElement.removeAttribute('data-space')
  } else {
    document.documentElement.setAttribute('data-space', mapped)
  }
}
